import _ from 'lodash';
import React from 'react';
import { View } from 'react-native';
import { BasicText } from '../Styles';

const OpidFlatList = ({data = [], renderItem = (item)=><BasicText>Missing</BasicText>, style = undefined, keyExtractor = (item, index) => index}) => {
    const elements = _.map(data, (d, index)=>{
        const key = keyExtractor(d, index);

        return <React.Fragment key={key}>
            {renderItem(d)}
        </React.Fragment>;
    });

    return <View style={style}>
        {elements}
    </View>;
}

export default OpidFlatList;